// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultEmpty__container-e77c31 {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.SearchResultEmpty__icon-a621e0 {
  width: 24px;
  height: 24px;
  fill: var(--base-80);
}

.SearchResultEmpty__text-dfd4d8 {
  color: var(--base-80);
  margin-inline-start: 8px;
  font: var(--font-body-4);
  letter-spacing: var(--font-body-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SearchResult/SearchResultEmpty/SearchResultEmpty.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,wBAAA;EACA,kCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  fill: var(--base-80);\n}\n\n.text {\n  color: var(--base-80);\n  margin-inline-start: 8px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-body-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchResultEmpty__container-e77c31`,
	"icon": `SearchResultEmpty__icon-a621e0`,
	"text": `SearchResultEmpty__text-dfd4d8`
};
module.exports = ___CSS_LOADER_EXPORT___;
